export default {
  categories: {
  shoes: 'Shoes',
  hoodies: 'Hoodies/Sweaters',
  tshirts: 'T-Shirts',
  jackets: 'Jackets',
  pants: 'Pants/Shorts',
  headwear: 'Headwear',
  sets: 'Sets',
  underwear: 'Underwear/Underpants',
  jersey: 'Jerseys',
  accessories: 'Accessories',
  bags: 'Bags',
  belts: 'Belts',
  perfumes: 'Perfumes',
  other: 'Other Stuff',
  },
};